/**
 * adminConstants.js — Shared API endpoint constants for Admin Dashboard tabs
 */

export const INVENTORY_API = "/api/inventory";
export const CATALOG_API = "/api/catalog";
export const ORDERS_API = "/api/orders";
export const CYCLES_API = "/api/cycles";
export const SUPPLY_TRANSACTIONS_API = "/api/supply-transactions";
